import { render, staticRenderFns } from "./ControlConfig.vue?vue&type=template&id=44d4b6fa&scoped=true&"
import script from "./ControlConfig.vue?vue&type=script&lang=ts&"
export * from "./ControlConfig.vue?vue&type=script&lang=ts&"
import style0 from "./ControlConfig.vue?vue&type=style&index=0&id=44d4b6fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d4b6fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VRow,VTextField})
